import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { seoMetadata } from '../data';

export default function SEO({ dynamicTitle, dynamicDescription }) {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    let title = "Munkgaard Træbyg ApS";
    let description = "Specialister indenfor træbyggeri, sommerhuse, tilbygninger og totalrenoveringer.";

    if (dynamicTitle) {
      title = `${dynamicTitle} - Munkgaard Træbyg ApS`;
    } else if (seoMetadata[location.pathname]) {
      title = seoMetadata[location.pathname].title;
    } else {
      // Fallback for subpages or dynamic paths
      const pathSegments = location.pathname.split('/').filter(Boolean);
      if (pathSegments.length > 0) {
        const lastSegment = pathSegments[pathSegments.length - 1];
        const formattedSegment = lastSegment
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        title = `${formattedSegment} - Munkgaard Træbyg ApS`;
      }
    }

    if (dynamicDescription) {
      description = dynamicDescription;
    } else if (seoMetadata[location.pathname]) {
      description = seoMetadata[location.pathname].description;
    }

    document.title = title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Update og:title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', title);

    // Update og:description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', description);

  }, [location.pathname, dynamicTitle, dynamicDescription]);

  return null;
}
